var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.metaDatas)?_c('MetaData',{attrs:{"data":_vm.metaDatas[0]}}):_vm._e(),_c('Showcase'),_c('SongKick')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }